<template>
    <div class="expenses-info">
        <div class="info-header" @click="changeState('isExpenseInfoShow')">
            <div class="info-header-left">
                <span class="info-header-block"></span>
                <span class="info-header-text">费用信息</span>
            </div>
            <i :class="['el-icon', 'mgr-10', isExpenseInfoShow ? 'el-icon-arrow-down' :'el-icon-arrow-right']"></i>
        </div>
        <el-form label-position="left" label-width="130px" class="expenses-wrapper" v-show="isExpenseInfoShow">
            <el-row>
                <el-col :span="6">
                    <el-form-item label="运输成本(元)：">
                        <span @dblclick="copyText($event)">{{ formateValue(basicInfo.transportationCost) }}</span>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="预付方式：">
                        <span @dblclick="copyText($event)">{{ basicInfo.payMethodName || '--' }}</span>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="油卡金额(元)：">
                        <span @dblclick="copyText($event)">{{ formateValue(basicInfo.oilcardPayAmount) }}</span>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="成本比例(%)：">
                        <span @dblclick="copyText($event)">{{ formateValue(basicInfo.costRate) }}</span>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="运输收入(元)：">
                        <!-- 产品要求，无论是否有值，默认展示为-- -->
                        <!-- 特别注意，该字段有展示权限，修改时，同步修改查询接口的字段格式化 -->
                        <span>--</span>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="信息费用(元)：">
                        <span @dblclick="copyText($event)">{{ formateValue(basicInfo.infoFee) }}</span>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="月度目标成本(元)：">
                        <span @dblclick="copyText($event)">{{ formateValue(basicInfo.standardCost) }}</span>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="是否串点计费：">
                        <span @dblclick="copyText($event)">{{ basicInfo.dmsFlagName || '--' }}</span>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="预付金额(元)：">
                        <span @dblclick="copyText($event)">{{ formateValue(basicInfo.prepaidAmount) }}</span>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="现汇税率(%)：">
                        <span @dblclick="copyText($event)">{{ formateValue(basicInfo.taxRate) }}</span>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="目标价：">
                        <span @dblclick="copyText($event)">{{ formateValue(basicInfo.targetPrice) }}</span>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="长合车计费新：">
                        <span @dblclick="copyText($event)">{{ basicInfo.mileageBillingTypeName || '--' }}</span>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="配送费(元)：">
                        <!-- 产品要求，无论是否有值，默认展示为-- -->
                        <span>--</span>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="日计费趟数：">
                        <span @dblclick="copyText($event)">{{ formateValue(basicInfo.ranksCount) }}</span>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="按趟计费标识：">
                        <span @dblclick="copyText($event)">{{ basicInfo.billingRanksFlagName || '--' }}</span>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="成本计费前置：">
                        <span @dblclick="copyText($event)">{{ basicInfo.billingCostAdvanceFlagName || '--' }}</span>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="是否计费前置：">
                        <span @dblclick="copyText($event)">{{ basicInfo.billingAdvanceFlagName || '--' }}</span>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
    </div>
</template>

<script>
import { copyToClip } from '../util.js';
export default {
    name: 'ExpensesInformation',
    props: {
        basicInfo: {
            type: Object,
            default () {
                return {};
            }
        }
    },
    data () {
        return {
            isExpenseInfoShow: true
        };
    },
    computed: {
        formateValue () {
            return function (val) {
                return (val !== null && val !== undefined && val !== '') ? val : '--';
            };
        }
    },
    methods: {
        changeState (state) {
            this[state] = !this[state];
        },
        /**
         * @description 双击复制
         * @param {*} e
         */
        copyText (e) {
            const value = (e.target.innerHTML).trim();
            value !== '--' && copyToClip(value);
        }
    }
};
</script>

<style lang="less" scoped>
@import '../dispatchInfoDetail.less';
.expenses-info {
    background-color: #fff;
    margin-bottom: 14px;
}
.expenses-wrapper {
    padding: 10px 0px 10px 20px;
}
</style>
